
/* Redaktion: Produktdaten und Limits zentral hier; Tabelle oben synchron halten.
 * Reine Kapazitätsrechnung. Keine API, Speicherung oder Gerätesteuerung.
 */
(() => {
  'use strict';
  const LIMITS = Object.freeze({ pods:60, units:60, leds:320, cols:12, rows:7 });
  const PRODUCTS = Object.freeze([
    { id:'mini', name:'NANO CUBE', units:1, leds:5, w:1, h:1, tone:'#38d5ff' },
    { id:'tower', name:'ROCKET', units:1, leds:5, w:1, h:2, tone:'#8eb7ff' },
    { id:'cube', name:'CUBE', units:2, leds:9, w:2, h:2, tone:'#ffac55' },
    { id:'long', name:'HORIZON', units:3, leds:11, w:3, h:1, tone:'#70dfb8' },
    { id:'double', name:'DOUBLE CUBE', units:3, leds:11, w:4, h:2, tone:'#d7a3ff' }
  ].map(Object.freeze));
  const PRESETS = Object.freeze({ mini:[60,0,0,0,0], mixed:[12,6,6,2,2], cube:[0,0,30,0,0], over:[61,0,0,0,0], empty:[0,0,0,0,0] });
  function analyze(counts) {
    if (!Array.isArray(counts) || counts.length !== PRODUCTS.length || counts.some(n => !Number.isInteger(n) || n < 0 || n > 120)) return { valid:false };
    const total = counts.reduce((a,b) => a+b,0);
    const units = counts.reduce((s,n,i) => s+n*PRODUCTS[i].units,0);
    const leds = 1+counts.reduce((s,n,i) => s+n*PRODUCTS[i].leds,0);
    const cells = counts.reduce((s,n,i) => s+n*PRODUCTS[i].w*PRODUCTS[i].h,0);
    const matrix = Array.from({ length:LIMITS.rows }, () => Array(LIMITS.cols).fill(false));
    const placed = [];
    // Simple deterministic first-fit: finding a placement proves it fits;
    // failing is NOT a proof that every possible arrangement would fail.
    const order = PRODUCTS.map((p,i) => ({ ...p, index:i })).sort((a,b) => b.h-a.h || b.w-a.w);
    for (const p of order) {
      for (let n=0; n<counts[p.index]; n++) {
        let position=null;
        for (let y=0; y<=LIMITS.rows-p.h && !position; y++) {
          for (let x=0; x<=LIMITS.cols-p.w; x++) {
            let free=true;
            for (let dy=0; dy<p.h; dy++) for (let dx=0; dx<p.w; dx++) if (matrix[y+dy][x+dx]) free=false;
            if (free) { position={x,y}; break; }
          }
        }
        if (!position) break;
        for (let dy=0; dy<p.h; dy++) for (let dx=0; dx<p.w; dx++) matrix[position.y+dy][position.x+dx]=true;
        placed.push({ product:p.index, x:position.x, y:position.y, w:p.w, h:p.h });
      }
    }
    return { valid:true, total, units, leds, cells, free:LIMITS.units-units,
      busOk:total<=LIMITS.pods && units<=LIMITS.units && leds<=LIMITS.leds,
      gridFits:placed.length===total, placed };
  }
  window.ModelpodCapacity = Object.freeze({ LIMITS, PRODUCTS, PRESETS, analyze });
  if (typeof document === 'undefined') return; // Enables isolated calculation tests.
  const $ = id => document.getElementById(id);
  const controls = $('controls');
  PRODUCTS.forEach(p => {
    const row=document.createElement('div'); row.className='pod-row';
    row.innerHTML='<div class="pod-shape" aria-hidden="true"><span></span></div><label class="pod-label" for="count-'+p.id+'">'+p.name+'<small>'+p.units+' Bus-Einheit'+(p.units===1?'':'en')+' pro Pod</small></label><div class="stepper"><button type="button" data-step="-1" aria-label="'+p.name+' verringern">−</button><input id="count-'+p.id+'" type="number" inputmode="numeric" min="0" max="120" step="1" value="0"><button type="button" data-step="1" aria-label="'+p.name+' erhöhen">+</button></div>';
    row.style.setProperty('--tone',p.tone); row.style.setProperty('--w',p.w); row.style.setProperty('--h',p.h);
    controls.append(row);
    row.querySelectorAll('button').forEach(button => button.addEventListener('click',() => {
      const input=row.querySelector('input');
      if (input.value==='' || !input.validity.valid) return;
      input.value=String(Math.max(0,Math.min(120,Number(input.value)+Number(button.dataset.step))));
      render();
    }));
  });
  $('budget').innerHTML='<span></span>'.repeat(LIMITS.units);
  $('legend').innerHTML=PRODUCTS.map(p => '<span style="--tone:'+p.tone+'">'+p.name+'</span>').join('');
  function render() {
    const inputs=PRODUCTS.map(p => $('count-'+p.id));
    const counts=inputs.map(input => input.value==='' ? NaN : Number(input.value));
    inputs.forEach((input,i) => {
      const invalid=!Number.isInteger(counts[i]) || counts[i]<0 || counts[i]>120 || !input.validity.valid;
      input.setAttribute('aria-invalid',String(invalid));
      const buttons=input.parentElement.querySelectorAll('button');
      buttons[0].disabled=invalid || counts[i]===0;
      buttons[1].disabled=invalid || counts[i]===120;
    });
    const result=analyze(counts);
    const valid=result.valid && inputs.every(input => input.validity.valid);
    $('inputError').hidden=valid; $('calculation').hidden=!valid; $('invalidResult').hidden=valid;
    if (!valid) {
      $('wall').replaceChildren(); $('wall').setAttribute('aria-label','Berechnung pausiert: ungültige Eingabe.');
      $('gridStatus').textContent='Bitte Eingabe korrigieren'; $('gridDetail').textContent='Solange eine Anzahl ungültig ist, zeigen wir keine alte Berechnung als aktuelles Ergebnis.';
      $('gridCells').textContent='– / 84 Rasterfelder'; return;
    }
    $('podTotal').textContent=result.total; $('busTotal').textContent=result.units;
    $('budgetFree').textContent=result.free>=0 ? result.free+' frei' : Math.abs(result.free)+' zu viel';
    let unitIndex=0;
    const dots=[...$('budget').children];
    dots.forEach(dot => { dot.className=''; dot.style.removeProperty('--tone'); });
    counts.forEach((n,i) => { for (let u=0; u<n*PRODUCTS[i].units && unitIndex<dots.length; u++) { const dot=dots[unitIndex++]; dot.className='used'; dot.style.setProperty('--tone',PRODUCTS[i].tone); } });
    $('result').dataset.state=!result.total ? 'empty' : result.busOk ? 'ok' : 'over';
    $('resultTitle').textContent=!result.total ? 'Noch keine Pods ausgewählt' : result.busOk ? 'Die Software-Busgrenzen passen.' : 'Die Software-Busgrenzen sind überschritten.';
    const problems=[];
    if (result.total>LIMITS.pods) problems.push((result.total-LIMITS.pods)+' Pods über der Anzahlgrenze');
    if (result.units>LIMITS.units) problems.push((result.units-LIMITS.units)+' Bus-Einheiten zu viel');
    if (result.leds>LIMITS.leds) problems.push('zusätzlich die interne LED-Adressgrenze überschritten');
    $('resultText').textContent=!result.total ? 'Wähle einen Beispielaufbau oder erhöhe die Anzahl eines Pod-Typs.' : result.busOk ? 'Noch '+result.free+' Bus-Einheiten verfügbar. Rasterplatz und elektrische Auslegung separat beachten.' : problems.join(' · ')+'. Bitte die Kette verkleinern.';
    const terms=counts.map((n,i) => n ? n+' × '+PRODUCTS[i].units+' ('+PRODUCTS[i].name+')' : '').filter(Boolean);
    $('formula').textContent=(terms.length ? terms.join(' + ') : '0')+' = '+result.units+' Bus-Einheiten';
    $('wall').replaceChildren();
    result.placed.forEach((pod,i) => {
      const el=document.createElement('div'); el.className='wall-pod'; el.textContent=i+1;
      el.title=PRODUCTS[pod.product].name+' · Beispiel-Pod '+(i+1);
      el.style.gridColumn=(pod.x+1)+' / span '+pod.w; el.style.gridRow=(pod.y+1)+' / span '+pod.h;
      el.style.setProperty('--tone',PRODUCTS[pod.product].tone); $('wall').append(el);
    });
    $('wall').setAttribute('aria-label',result.placed.length+' von '+result.total+' Pods im Beispielraster platziert.');
    $('gridCells').textContent=result.cells+' / 84 Rasterfelder benötigt';
    $('gridStatus').textContent=!result.total ? 'Die Wand ist noch leer.' : result.gridFits ? 'Eine passende Anordnung gefunden.' : result.cells>84 ? 'Mehr Fläche nötig, als das Raster bietet.' : 'Keine vollständige Anordnung gefunden.';
    $('gridDetail').textContent=!result.total ? 'Jeder Pod belegt je nach Form unterschiedlich viele Rasterfelder.' : result.gridFits ? 'Alle '+result.total+' Pods passen in diese Beispielanordnung. '+(result.busOk ? 'Auch die Software-Busgrenzen sind eingehalten. Die Stromversorgung ist damit nicht geprüft.' : 'Achtung: Trotz passender Fläche sind die Software-Busgrenzen überschritten!') : result.placed.length+' von '+result.total+' Pods gezeichnet. '+(result.cells>84 ? 'Allein die benötigte Fläche übersteigt die 84 vorhandenen Rasterfelder. Das Busbudget ist davon unabhängig.' : 'Die automatische Vorschau konnte den Rest nicht platzieren. Das beweist bei gemischten Formen nicht, dass es keine andere passende Anordnung gibt.');
  }
  function preset(name) { PRODUCTS.forEach((p,i) => { $('count-'+p.id).value=PRESETS[name][i]; }); render(); }
  controls.addEventListener('input',render);
  document.querySelectorAll('[data-preset]').forEach(button => button.addEventListener('click',() => preset(button.dataset.preset)));
  $('print').addEventListener('click',() => window.print());
  let printDetails=[];
  addEventListener('beforeprint',() => { printDetails=[...document.querySelectorAll('details')].map(el => [el,el.open]); printDetails.forEach(([el]) => { el.open=true; }); });
  addEventListener('afterprint',() => printDetails.forEach(([el,open]) => { el.open=open; }));
  preset('mixed');
})();
